// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"_28sZ8bVyTR83","disclaimer__inner":"_1tEERIAVg05g","disclaimer__icon":"VAthVpNAylH4","disclaimer__paragraph":"_293Fyvpa5_Pk"};